import { useState, useEffect } from "react";
import axios from "axios";

const withAnalytics = (Component) => {
  const Analytics = (props) => {
    const [analytics, setAnalytics] = useState({});

    useEffect(() => {
      axios({
        method: "get",
        baseURL: "https://app.opentaxi.fi/api/",
        url: "/analytics/",
        headers: { "content-type": "application/json" },
      })
        .then((response) => {
          setAnalytics(response.data);
        })
        .catch(() => {
          // keep previous analytics object on failure
        });
    }, []);

    return <Component {...props} analytics={analytics} />;
  };
  Analytics.displayName = "Analytics";
  return Analytics;
};

withAnalytics.defaultProps = {};

withAnalytics.propTypes = {};

export default withAnalytics;
